module.exports = require("./material-design-icons.css");
